import {makeAction, makeAsyncAction} from 'common/utils/simplifiedAsync';

const mac = (actionName) => makeAction(actionName, 'anodot/app/');
const macAsync = (actionName) => makeAsyncAction(actionName, 'anodot/app/');

export const fetchCurUserOpenAlertsCount = macAsync('FETCH_CUR_USER_OPEN_ALERTS_COUNT');
export const saveUrlWithParams = mac('SAVE_APP_NAV_BAR_URL_PARAMS');
export const updateNavBarItemById = mac('UPDATE_NAV_BAR_ITEM_BY_ID');
